import { ModuleWithProviders, NgModule } from '@angular/core';

import { SharedModule } from '../common/shared.module';
import { UserRoutingModule } from './user-routing.module';

import { UserBasicInfoComponent } from './user-basic-info/user-basic-info.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UsersComponent } from './user-list/users.component';
import { UserHeaderComponent } from './user-header/user-header.component';
import { UserPhotoComponent } from './user-photo/user-photo.component';

import { UserService } from './user.service';
import { UserOfficeInfoComponent } from './user-office-info/user-office-info.component';
import { MultiselectControlModule } from '@mt-ng2/multiselect-control';

@NgModule({
    declarations: [UsersComponent, UserHeaderComponent, UserDetailComponent, UserBasicInfoComponent, UserPhotoComponent, UserOfficeInfoComponent],
    imports: [SharedModule, UserRoutingModule, MultiselectControlModule],
})
export class UserModule {
    static forRoot(): ModuleWithProviders<UserModule> {
        return {
            ngModule: UserModule,
            providers: [UserService],
        };
    }
}
